// extracted by mini-css-extract-plugin
export var dropdownIcon = "_se-6";
export var imgContainer = "_se-3";
export var menuIcon = "_se-5";
export var pillWrapper = "_se-2";
export var pillsContainer = "_se-1";
export var subscriptionCard = "_se-0";
export var subscriptionLogo = "_se-4";